import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SalesreppopupComponent } from './salesreppopup.component';



const routes: Routes = [
    {
        path: '',
        component: SalesreppopupComponent,
        data: {
            title: 'Manage Sales Rep'
        }
    },
    {
        path: ':id/:actionInfo',
        component: SalesreppopupComponent,
        data: {
            title: 'Manage Sales Rep'
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class  SalesRepPopupRoutingModule { }
